import { FeatureFlagName } from "../../../mp-utils/generic-utils/feature-flags/types"
import { DetailsDataProviderConfigType } from "./types"

export const QUERY_DETAILS_DATA_KEY = "DETAILS-DATA-KEY"

export const DETAILS_DATA_PROVIDER_CONFIG: Record<
  string,
  Record<string, DetailsDataProviderConfigType>
> = {
  "teaching-tools": {
    assignments: {
      dataSource: "graphql"
    },
    "test-administration": {
      dataSource: "graphql"
    }
  },
  organization: {
    organizations_id: {
      dataSource: "graphql",
      graphqlFeatureFlag:
        FeatureFlagName.reporting_graphql_organization_organizations
    },
    states_id: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_states
    },
    districts_id: {
      dataSource: "graphql",
      graphqlFeatureFlag:
        FeatureFlagName.reporting_graphql_organization_districts
    },
    schools_id: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_schools
    },
    admins_id: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_admins
    },
    teachers_id: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_teachers
    },
    classes_id: {
      dataSource: "graphql",
      graphqlFeatureFlag: FeatureFlagName.reporting_graphql_organization_classes
    },
    students_id: {
      dataSource: "graphql",
      graphqlFeatureFlag:
        FeatureFlagName.reporting_graphql_organization_students
    }
  }
}
